import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CounterSlice {
  navigatedFromCT: boolean;
}

const initialState: CounterSlice = {
  navigatedFromCT: false,
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setCounterData(_, action: PayloadAction<CounterSlice>) {
      return action.payload;
    },
    clearCounterData() {
      return initialState;
    },
  },
});

export const { setCounterData, clearCounterData } = counterSlice.actions;

export default counterSlice.reducer;
